// 繁體中文語言包
export default {
	// 導航
	nav: {
		home: '首頁',
		company: '公司簡介',
		about: '牌照資料',
		products: '產品介紹',
		download: '軟體下載',
		news: '資訊公告',
		contact: '聯絡我們',
	},

	// 頂部欄
	topbar: {
		hotline: '服務熱線',
		openAccount: '線上開戶',
		demoTrading: '模擬交易',
		bookAccount: '預約開戶',
	},

	// Hero區域
	hero: {
		title1: '領航行業趨勢 構築頂尖國際化投資生態',
		desc1: '實時洞悉市場脈搏，依托金融科技深挖價值窪地。整合全球優質資源，搭建穩定可靠的交易體系，為客戶財富穩健增長保駕護航。',
		title2: '專業金融服務 智慧投資未來',
		desc2: '前瞻國際為您提供全球化的交易服務，助您在金融市場中把握每一個機遇',
		title3: '凝聚全球智慧 賦能投資者多元發展路徑',
		desc3: '集結全球金融領域專家，共享前沿策略與實戰經驗。定制創新型解決方案，科學管理風險，精準發掘潛力投資賽道。',
	},
	video: {
		title: "遊隼上線，再啟新程",
		title1: "智能量化模型功能展示",
		title2: "全市場智能篩選，構建核心股池",
		description: "註：視頻內容僅用於展示模型部分功能，不構成任何投資建議或投資依據，市場有風險，投資需謹慎。",
		notSupported: "智能量化模型功能展示"
	},
	// 公司簡介
	company: {
		companyName: '前瞻金融投資管理國際有限公司',
		badge: '前瞻國際',
		subtitle: '香港證監會持牌法團 全球金融市場覆蓋',
		coverage: '全球金融市場覆蓋',
		btnText: '了解前瞻國際',
		introTitle: '公司介紹',
		profileSub: 'COMPANY PROFILE',
		intro: '前瞻金融投資管理國際有限公司成立於2021年，是一家專業的金融服務機構。作為香港證監會的認可持牌法團，我們致力為客戶提供全面的證券交易服務。',
		intro2: '憑藉豐富的行業經驗和專業的團隊，我們為客戶提供精準的市場分析和高效的交易執行，幫助客戶在全球金融市場中實現投資目標。',
		introFull1: '前瞻金融投資管理國際有限公司持有香港證券及期貨事務監察委員會牌照，具備從事《證券及期貨條例》中規定的第一類受規管活動（證券交易）、第四類受規管活動（就證券提供意見）及第九類受規管活動（提供資產管理）的資格，香港證監會中央編號為BRV554。',
		introFull2: '中規定的第一類受規管活動《證券交易》、第四類受規管活動《就證券提供意見》及第九類受規管活動《提供資產管理》的資格，香港證監會中央編號為BRV554。',
		introFull3: '',
	},

	// 產品介紹
	product: {
		productTitle: '業務架構',
		descFull: '  隨著全球資產配置需求持續提升，量化投資、智能投顧與金融科技正成為投資管理行業的重要發展方向。前瞻金融投資管理國際有限公司圍繞量化投資研究、智能策略服務及金融科技應用，進一步梳理業務布局，形成了以前瞻國際為核心、以前瞻量化為策略品牌、以前瞻致驅為運營支撐的協同發展架構。',
		descFull2: '  在這一體系中，前瞻量化扮演著重要角色。作為前瞻金融投資管理國際有限公司重點打造的量化投資研究與智能策略服務品牌，前瞻量化主要聚焦量化模型研發、市場數據分析、策略組合構建、風控體系建設以及智能化投資輔助工具開發。相比傳統投研模式，前瞻量化更強調數據驅動、模型驗證和紀律化執行，希望通過更加系統的方法，為投資者提供理性、清晰、可追蹤的投資決策支持。',
		descFull3: '  前瞻致驅則承擔著前瞻國際在內地的運營管理與技術服務支持職能。其工作重點包括品牌運營、技術協同、市場服務、投研內容支持及客戶服務體系建設等。通過香港機構的專業資質、量化品牌的策略研發能力，以及內地運營主體 Servicing 的支持，三者之間形成了較為清晰的分工關係。',
	},

	// 產品服務（Products頁面）
	products: {
		bannerTitle: '產品介紹',
		bannerDesc: '證券作為現代金融體系的核心風險管理工具，幫助買賣雙方有效規避價格波動風險，是連接實體經濟與虛擬資本的關鍵紐帶。',
		sectionTitle: '證券業務介紹',
		sectionSub: 'GLOBAL SECURITIES INTRODUCTION',
		introFull: '作為現代金融體系的核心投資工具，證券通過標準化的股票、債券、基金等產品，為企業提供直接融資渠道，為投資者搭建資產增值平台。自全球證券市場規範化發展以來，歷經百年演進，已形成覆蓋全球主要經濟體的多層次資本市場體系。隨著金融全球化與數字化發展，環球證券市場成為連接實體經濟與社會資本的核心橋梁，全球證券市場總市值規模持續穩定增長。',
		marketTitle: '市場功能與結構演變',
		marketIntro: '環球證券市場兼具融資服務與資產配置雙重功能：',
		assetGrowth: '資產增值',
		assetGrowthDesc: '投資者通過投資股票、基金等證券產品，分享優質企業成長紅利，實現長期資產保值與增值，是全球主流的財富管理方式。',
		wealthMgmt: '財富管理',
		wealthMgmtDesc: '依托港股、美股、A股等全球主要市場，支持多樣化投資組合配置，T+0/ T+1靈活交易機制，滿足個人與機構的多元化財富管理需求。',
		systemTitle: '產品體系：從基礎股票到綜合金融產品',
		systemIntro: '當前環球證券市場呈現三大特徵：',
		categoryTitle: '品類多元化',
		featStock: '股票產品',
		featStockDesc: '覆蓋港股、美股、滬深A股等全球主流市場，包含藍籌股、科技股、醫藥股等全品類標的，滿足不同風險偏好投資者需求。',
		featFund: '基金理財',
		featFundDesc: '提供公募基金、私募基金、ETF等產品，由專業機構管理，分散投資風險，適合穩健型投資者進行長期配置。',
		featBond: '債券產品',
		featBondDesc: '政府債券、企業債券、可轉債等固定收益產品，收益穩定、風險較低，是資產配置中重要的避險工具。',
		overlayTitle: '專業合規',
		overlayDesc: '持有香港證監會(SFC)1號及4號、9號牌照',
		serviceProviderTitle: '作為專業環球證券服務商',
		serviceProviderDesc: '作為專業環球證券服務商，前瞻國際整合全球核心交易所資源，包括香港聯交所、紐約證券交易所、納斯達克等，為客戶提供覆蓋全球主流證券品種的一站式交易服務。通過合規高效的服務通道，投資者可便捷參與港股、美股、A股等市場交易，享受低傭金、透明定價與專業的投資服務。',
		trendTitle: '發展趨勢與價值',
		trendDesc: '當前，環球證券市場持續向數字化、全球化、多元化發展，ESG投資、智能投顧等創新服務快速普及。隨著監管體系持續完善與投資者專業度提升，證券市場作為全球資本配置核心平台的價值將進一步凸顯，助力個人與機構把握全球投資機遇，實現財富穩健增長。',
	},

	// 軟體下載（Download頁面）
	download: {
		bannerTitle: '軟體下載',
		bannerDesc: '下載官方認證的交易軟體與輔助工具，助力您穩定、高效開展各類投資交易操作。',
		sectionTitle: '交易軟體下載',
		sectionSub: 'TRADING SOFTWARE DOWNLOAD',
		platformDesc: '前瞻致驅採用先進的系統架構與開發技術，具備多點部署、主中心統一管理、分布式運行及多中心協同能力，可根據實際業務需求靈活配置災備、熱備、備援架構及跨區域服務方案，保障系統穩定運行與業務連續性。',
		serviceTitle: '為用戶提供更好、更專業的軟體服務平台',
		serviceDesc: '前瞻致驅承擔前瞻國際在內地的運營管理與技術服務支持職能，圍繞品牌運營、技術協同、市場服務、投研內容及客戶服務體系建設開展工作。',
		appSubtitle: '前瞻致驅APP用戶端下載',
		iosBadge: '蘋果',
		iosDownloadText: 'App Store搜尋：前瞻致驅',
		androidBadge: '安卓',
		androidDownloadText: '應用商店搜尋：前瞻致驅',
		guideTitle: '使用指南',
		step1Title: '下載安裝',
		step1Desc: '根據您的設備類型選擇對應的用戶端版本進行下載並安裝。',
		step2Title: '帳號登錄',
		step2Desc: '使用開戶時獲取的帳號和密碼登錄交易平台。首次登錄需修改密碼。',
		step3Title: '開始交易',
		step3Desc: '瀏覽行情、研究分析後，即可開始您的交易之旅。',
	},

	// 數據統計
	stats: {
		compliance: '專業合規',
		license: '持有香港證監會(SFC)1號及4號、9號牌照',
		exchanges: '全球主力交易所',
		founded: '成立年份',
		coverage: '全球市場覆蓋（小時）',
	},

	// 關於我們（牌照信息）
	about: {
		bannerTitle: '牌照資料',
		sectionTitle: '牌照資料',
		sectionSub: 'ABOUT QIANZHAN',
		licenseTitle: '牌照信息',
		licenseDesc1: '前瞻金融投資管理國際有限公司持有香港證券及期貨事務監察委員會（SFC）頒發的受規管活動牌照，具備從事《證券及期貨條例》中規定的第一類受規管活動（證券交易）、第四類受規管活動（就證券提供意見）及第九類受規管活動（提供資產管理）的資格。',
		licenseDesc2: '中央編號為BNG583，是經香港證監會正式認可的專業持牌法團，嚴格遵守相關監管規定，確保客戶資金安全與交易公平。',
		complianceTitle: '監管合規',
		complianceDesc: '作為香港證券及期貨事務監察委員會（SFC）認可的持牌法團，我們嚴格遵守《證券及期貨條例》及相關監管規定：',
		compliance1: '客戶資產獨立託管，與公司資產完全隔離',
		compliance2: '定期接受香港證監會審計與檢查',
		compliance3: '完善的內部風險控制體系',
		compliance4: '透明的費用結構與交易規則',
		licenseTypes: '第1/4/9類牌照',
		centralNo: '中央編號',
		regulator: '監管機構',
	},

	// 客戶服務
	service: {
		title: '客戶服務',
		subtitle: '我們提供全方位的客戶服務，確保您的交易體驗順暢便捷',
		download: {
			title: '軟體下載',
			desc: '下載我們的交易軟體，隨時隨地開展交易',
		},
		deposit: {
			title: '出入金服務',
			desc: '多種資金進出渠道，滿足您的資金管理需求',
		},
		account: {
			title: '線上開戶',
			desc: '簡單快速完成開戶流程，開啟您的投資之旅',
		},
	},
	news: {
		"bannerTitle": "資訊公告",
		"bannerDesc": "追蹤公司動態，掌握市場前沿的金融策略",
		"tabCompany": "公司公告",
		"tabMedia": "媒體聚焦",
		"tabNotice": "通知公告",
		"hotArticlesTitle": "熱門文章",
		"backToList": "← 返回列表"
	},
	// 聯絡我們（Contact頁面）
	contact: {
		bannerTitle: '聯絡我們',
		bannerDesc: '無論您有任何投資相關的問題或需求，我們都願意傾聽並為您提供專業支持。歡迎通過多種方式與我們取得聯絡。',
		sectionTitle: '聯絡方式',
		sectionSub: 'CONTACT US',
		introText: '前瞻國際致力於為全球投資者提供專業的證券交易服務與投資咨詢支持。無論您是個人投資者還是機構客戶，我們的專業團隊都將竭誠為您服務。您可以通過以下方式與我們取得聯絡，我們將盡快回覆您的咨詢。',
		emailTitle: '電子郵件',
		emailValue: 'invisionasset@gmail.com',
		addressTitle: '公司地址',
		addressValueCN: '香港尖沙咀廣東道28號力寶太陽廣場4樓408C室',
		addressValueEN: 'Unit 408C, 4/F, Lippo Sun Plaza, 28 Canton Road, Tsim Sha Tsui, Hong Kong',
		mapTitle: '公司位置',
		mapDesc: '查看我們在香港九龍尖沙咀地理位置',
	},

	// 底部
	footer: {
		copyright: 'Copyright © 2021 前瞻金融投資管理國際有限公司 版權所有 ',
	},

	// 頁面標題
	pages: {
		companyTitle: '公司簡介',
		aboutTitle: '牌照資料',
		productsTitle: '產品介紹',
		downloadTitle: '軟體下載',
		newsTitle: '資訊公告',
		contactTitle: '聯絡我們',
	},

	// 語言切換
	langSwitch: {
		zhCN: '簡',
		zhTW: '繁',
	},
}